export const validateTimeslot = (
  timeslots: Array<{ fromTime: string; toTime: string }>,
  newSlot: { fromTime: string; toTime: string },
  index: number,
) => {
  const errors: { fromTime?: string; toTime?: string } = {};

  if (newSlot.fromTime >= newSlot.toTime) {
    errors.toTime = 'End time must be later than start time';
  }

  timeslots.forEach((slot, i) => {
    if (
      i !== index &&
      ((newSlot.fromTime >= slot.fromTime && newSlot.fromTime < slot.toTime) ||
        (newSlot.toTime > slot.fromTime && newSlot.toTime <= slot.toTime) ||
        (newSlot.fromTime <= slot.fromTime && newSlot.toTime >= slot.toTime))
    ) {
      errors.fromTime = 'Start time slot overlaps with another';
      errors.toTime = 'End time slot overlaps with another';
    }
  });

  return errors;
};


const getTimezoneOffset = (timezone: string): string => {
  const now = new Date();
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    hourCycle: 'h23',
    hour: '2-digit',
    minute: '2-digit',
  });

  const parts = formatter.formatToParts(now);
  const localHour = parseInt(parts.find((p) => p.type === 'hour')?.value || '0', 10);
  const utcHour = now.getUTCHours();
  const offset = localHour - utcHour;

  const sign = offset >= 0 ? '+' : '-';
  const absOffset = Math.abs(offset).toString().padStart(2, '0');
  return `${sign}${absOffset}:00`;
};


export const calculateCustomHours = (
  selectedDate: Date,
  fromTime: string,
  toTime: string,
  coachTimezone: string,
): { fromDateTime: string; toDateTime: string } => {
  const fromDateTime = new Date(selectedDate);
  const toDateTime = new Date(selectedDate);

  const [fromHours, fromMinutes] = fromTime.split(':').map(Number);
  const [toHours, toMinutes] = toTime.split(':').map(Number);

  fromDateTime.setHours(fromHours, fromMinutes, 0, 0);
  toDateTime.setHours(toHours, toMinutes, 0, 0);

  const pad = (num: number) => String(num).padStart(2, '0');

  const fromISOString = `${fromDateTime.getFullYear()}-${pad(fromDateTime.getMonth() + 1)}-${pad(fromDateTime.getDate())}T${pad(fromHours)}:${pad(fromMinutes)}:00${getTimezoneOffset(coachTimezone)}`;
  const toISOString = `${toDateTime.getFullYear()}-${pad(toDateTime.getMonth() + 1)}-${pad(toDateTime.getDate())}T${pad(toHours)}:${pad(toMinutes)}:00${getTimezoneOffset(coachTimezone)}`;

  return {
    fromDateTime: fromISOString,
    toDateTime: toISOString,
  };
};
